import tubos from "../assets/tubos.jpg"
import desinfectante from "../assets/desinfectante.jpg"
import sutura from "../assets/sutura.jpg"
import centrifugadora from "../assets/centrifugadora.jpg"
import equipoMedico from "../assets/equipoMedico.jpg"
import lampara from "../assets/lampara.jpg"
export default function Products() {
  const products = [
    {
      title: "Tubos de Recolección de Sangre",
      description: "Tubos para recolección de sangre de alta calidad y esterilidad garantizada.",
      image: tubos
    },
    {
      title: "Detergente y Desinfectante",
      description: "Detergentes y desinfectantes de alta calidad para entornos médicos, no tóxicos y biodegradables.",
      image: desinfectante
    },
    {
      title: "Suturas Quirúrgicas",
      description: "Suturas quirúrgicas biodegradables, no tóxicas, no irritantes y sin residuos dañinos. Ideales para procedimientos médicos seguros.",
      image: sutura
    },
    {
      title: "Equipos de Laboratorio",
      description: "Centrifugadoras, microscopios y analizadores para laboratorios médicos de vanguardia.",
      image: centrifugadora
    },
    {
      title: "Suministro Médico",
      description: "Guantes, mascarillas, jeringas y otros suministros médicos esenciales.",
      image: equipoMedico
    },
    {
      title: "Lámpara Quirúrgica",
      description: "Lámpara quirúrgica de alta intensidad para salas de cirugía, proporcionando iluminación óptima.",
      image: lampara
    }
  ];

  return (
    <section id="productos" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Nuestros Productos</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Equipamiento médico de vanguardia para tu institución
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

          {products.map((p, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-8 border hover:shadow-lg transition">
              
              {/* 📌 Imagen del producto */}
              <img
                src={p.image}
                alt={p.title}
                className="w-full h-48 object-contain rounded-lg mb-4"
              />

              <h3 className="text-xl font-bold">{p.title}</h3>
              <p className="text-gray-600 mt-2">{p.description}</p>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}
